module.exports = __webpack_public_path__ + "img/home_lenders_mobile.ec1c7329.jpg";